/**
 * Int32 wrap helper for string hashing.
 *
 * Hash loops here rely on 32-bit signed *overflow wrap* (the same thing `| 0`
 * did), not on decimal truncation — `Math.trunc` would keep values above
 * 2^31 - 1 intact and change every fingerprint / palette index that overflows.
 * Assigning through an `Int32Array` applies the exact same ToInt32 conversion
 * as `| 0` without the bitwise operator Sonar flags (`typescript:S7767`).
 */

const int32View = new Int32Array(1)

/** Wrap `n` to a signed 32-bit integer — identical output to `n | 0`. */
export function toInt32(n: number): number {
  int32View[0] = n
  return int32View[0]!
}
